// state/campaigns.reducer.ts
import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { CampaignsActions } from './actions';
import {
  ApiCampaign,
  Campaign,
  SelectionSource,
} from '../../types/campaigns.models';
import { adaptCampaign } from '../../services/campaigns/service';

export interface CampaignsState extends EntityState<Campaign> {
  selectedId: string | null;
  source: SelectionSource;
  loading: boolean;
  error: unknown | null;
}

export const campaignsAdapter = createEntityAdapter<Campaign>({
  selectId: (c) => c.id,
  sortComparer: false, // ¡mantener orden de inserción ya pre-ordenado por el servicio!
});

export const initialState: CampaignsState = campaignsAdapter.getInitialState({
  selectedId: null,
  source: null,
  loading: false,
  error: null,
});

export const campaignsReducer = createReducer(
  initialState,

  on(CampaignsActions.load, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(CampaignsActions.loadSuccess, (state, { campaigns }) => {
    const newState = campaignsAdapter.setAll(campaigns, {
      ...state,
      loading: false,
      error: null,
    });

    // Selección automática si no hay selección previa
    if (!newState.selectedId && campaigns.length > 0) {
      return {
        ...newState,
        selectedId: campaigns[0].id,
        source: 'auto' as const,
      };
    }
    return newState;
  }),

  on(CampaignsActions.loadFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(CampaignsActions.select, (state, { id, source }) => ({
    ...state,
    selectedId: id,
    source,
  })),

  on(CampaignsActions.clearSelection, (state) => ({
    ...state,
    selectedId: null,
    source: null,
  })),

  //actualizar basado en lo que nos diga signalr
  on(CampaignsActions.realtimeCampaignReceived, (state, { campaign }) => {
    // donation viene crudo (Cosmos/SignalR) con PascalCase
    const normalized = adaptCampaign(campaign as ApiCampaign);

    return campaignsAdapter.upsertOne(normalized, state);
  })
);
